// extracted by mini-css-extract-plugin
export var footer = "_md-0";
export var inherit = "_md-1";
export var input = "_md-2";
export var modalContent = "_md-3";
export var quillEditor = "_md-4";
export var subtitle = "_md-5";